// extracted by mini-css-extract-plugin
export default {"button":"index_button__nNd7C"};